import { render, staticRenderFns } from "./fullpage-nav-button.vue?vue&type=template&id=c81a46d4&scoped=true"
import script from "./fullpage-nav-button.vue?vue&type=script&lang=js"
export * from "./fullpage-nav-button.vue?vue&type=script&lang=js"
import style0 from "./fullpage-nav-button.vue?vue&type=style&index=0&id=c81a46d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c81a46d4",
  null
  
)

export default component.exports